import io from "socket.io-client";
import {getStoredSessionId, storeSessionId} from "./sessionStore";

const socket = io(process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000',
    {withCredentials: true});

const sessionId = getStoredSessionId()
if(sessionId) {
    socket.auth = {sessionId}
    socket.sessionId = sessionId
}

socket.on("session", ({sessionId}) => {
    console.log("Received session id: " + sessionId)
    socket.auth = {sessionId}
    socket.sessionId = sessionId
    storeSessionId(sessionId)
    window.dispatchEvent(new CustomEvent('session-id-updated', {detail: {sessionId}}))
})

// socket.io saves up events emitted while the connection is down and sends them all once it is back. For actions like
// creating or joining a game that is the wrong thing to do (a few impatient clicks turn into several offers at once),
// so those are only sent when we are connected. Returns false when nothing was sent.
export const emitNow = (event, data) => {
    if (!socket.connected) return false;
    socket.emit(event, data);
    return true;
};

export const OFFLINE_TOAST = {
    id: "offline-action",
    tone: "danger",
    title: "You are offline",
    text: "Nothing was sent. Wait until the connection is back, then try again.",
    duration: 4000
};

export default socket